( function( $ ) {
	"use strict";

	$( document ).ready( function() {
		$( document ).on( 'click', '#ar', function( e ) {
			e.preventDefault();

			$( '.ar-popup' ).addClass( 'show' );
			$( 'body' ).addClass( 'popup-ar-lock' );
		} );

		/**
		 * Close button.
		 */
		$( document ).on( 'click', '.ar-popup a[href="#close"]', function( e ) {
			e.preventDefault();

			$( '.ar-popup' ).removeClass( 'show' );
			$( 'body' ).removeClass( 'popup-ar-lock' );
		} );
	} );

} )( jQuery );
